export const AUDIT_EVENTS = `
query auditEvents(
  $tenant_id: Int!
  $filter: FilterAuditEventInput
  $orderBy: AuditEventOrderInput
  $skip: Int
  $take: Int
  $searchText: String
) {
  auditEvents(
    tenant_id: $tenant_id
    filter: $filter
    orderBy: $orderBy
    skip: $skip
    take: $take
    searchText: $searchText
  ) {
    __typename
    ... on AuditEvent {
      id
      event_type
      target_user_id
      target_user {
        username
      }
      actor_user_id
      actor_user {
        username
      }
      ip_address
      user_agent
      metadata
      its
    }
    ... on ResultError {
      status_code
      message
    }
  }
}
`;

export const AUDIT_EVENTS_COUNT = `
query auditEventsCount(
  $tenant_id: Int!
  $filter: FilterAuditEventInput
  $searchText: String
) {
  auditEventsCount(
    tenant_id: $tenant_id
    filter: $filter
    searchText: $searchText
  ) {
    __typename
    ... on Count {
      count
    }
    ... on ResultError {
      status_code
      message
    }
  }
}

`;
